import { DateTime } from 'luxon';
import React, { useState } from 'react'
import { MdArrowLeft, MdArrowRight } from "react-icons/md";
import { DATE_FORMAT_SERVER } from '../../../../constants';

const MonthlyCalendar = ({
    dateRanges,
    setDateRanges,
}) => {
    const [year, setYear] = useState(
        dateRanges.length > 0
            ? DateTime.fromISO(dateRanges[0].start).year
            : DateTime.now().year
    );

    const handlePrevYear = () => setYear(prev => prev - 1);
    const handleNextYear = () => setYear(prev => prev + 1);

    // Generate an array of months with the correct year
    const months = Array.from({ length: 12 }, (_, i) =>
        DateTime.fromObject({ year, month: i + 1 })
    );

    const isMonthSelected = (monthStart) => {
        const formatted = monthStart.toFormat(DATE_FORMAT_SERVER);
        return dateRanges.some(range => range.start === formatted);
    };

    const toggleMonth = (month) => {
        const start = month.startOf("month").toFormat(DATE_FORMAT_SERVER);
        const end = month.endOf("month").toFormat(DATE_FORMAT_SERVER);

        const alreadySelected = dateRanges.some(range => range.start === start);

        if (alreadySelected) {
            // Don't allow deselecting the last one
            if (dateRanges.length <= 1) return;
            setDateRanges(dateRanges.filter(range => range.start !== start));
        } else {
            // Add and sort by start date
            const updated = [...dateRanges, { start, end }];
            updated.sort((a, b) => a.start.localeCompare(b.start));
            setDateRanges(updated);
        }
    };

    return (
        <div className='z-[100] absolute top-0 right-0 p-5 bg-white w-[300px] shadow-xl'>
            <div className='flex items-center justify-between'>
                <button
                    onClick={handlePrevYear}
                    type='button'
                    className='w-[20px] h-[20px] bg-gray-200 rounded-[2px] flex items-center justify-center'
                >
                    <MdArrowLeft className="text-xl flex-shrink-0" />
                </button>
                <p className='text-sm font-bold'>
                    {year}
                </p>
                <button
                    onClick={handleNextYear}
                    type='button'
                    className='w-[20px] h-[20px] bg-gray-200 rounded-[2px] flex items-center justify-center'
                >
                    <MdArrowRight className="text-xl flex-shrink-0" />
                </button>

            </div>

            {/* Month Grid */}
            <div className='mt-3 grid grid-cols-3 gap-2'>
                {months.map((month, index) => {
                    const selected = isMonthSelected(month.startOf("month"));
                    return (
                        <button
                            key={index}
                            onClick={() => toggleMonth(month)}
                            type="button"
                            className={`transition-all text-xs text-center p-2 rounded font-medium 
                                hover:cursor-pointer hover:bg-primary hover:text-white
                                ${selected ? "bg-primary text-white" : "bg-gray-100"}
                            `}
                        >
                            {month.toFormat('MMMM')}
                        </button>
                    );
                })}
            </div>

            {/* Selected badges */}
            <div className='mt-3 flex flex-wrap gap-1 max-h-[80px] overflow-y-auto'>
                {dateRanges.map((range, i) => {
                    const label = DateTime.fromISO(range.start).toFormat('MMM yyyy');
                    return (
                        <span
                            key={range.start}
                            className='inline-flex items-center gap-1 px-2 py-0.5 bg-primary/10 text-primary text-xs rounded-full font-medium'
                        >
                            {label}
                            {dateRanges.length > 1 && (
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setDateRanges(dateRanges.filter(r => r.start !== range.start));
                                    }}
                                    className='hover:text-red-500 font-bold text-[10px] leading-none'
                                >
                                    ✕
                                </button>
                            )}
                        </span>
                    );
                })}
            </div>
        </div>
    )
}

export default MonthlyCalendar